var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.13,27.72a16.36,16.36,0,0,1,3.61,10.37,3,3,0,0,1-3.09,3.07,3.06,3.06,0,0,1-3-3,11.51,11.51,0,0,0-.15-1.76,10.67,10.67,0,0,0-10.67-8.92H16.91l-.64,0,.41.49c2,2.25,4.06,4.49,6.07,6.74a3.07,3.07,0,1,1-4.5,4.18q-5.6-6.16-11.14-12.38a3,3,0,0,1-.27-3.87c.35-.47.73-.92,1.12-1.35Q13,15.65,18.06,10a3.1,3.1,0,0,1,4.46-.46,3.05,3.05,0,0,1,.16,4.51c-1.17,1.32-2.36,2.62-3.53,3.93l-2.93,3.26H26.87a16.13,16.13,0,0,1,2.08.13A16.63,16.63,0,0,1,40.13,27.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.fb18fa86b71e0d3c9fe98388c9fb7a44.svg";
export { ForwardRef as ReactComponent };